
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.66634 7.49998C2.66634 5.10675 4.60644 3.16665 6.99967 3.16665C9.39291 3.16665 11.333 5.10675 11.333 7.49998C11.333 9.89321 9.39291 11.8333 6.99967 11.8333C4.60644 11.8333 2.66634 9.89321 2.66634 7.49998ZM6.99967 1.83331C3.87006 1.83331 1.33301 4.37037 1.33301 7.49998C1.33301 10.6296 3.87006 13.1666 6.99967 13.1666C8.32425 13.1666 9.54269 12.7122 10.5075 11.9507L13.1949 14.6381C13.4553 14.8984 13.8774 14.8984 14.1377 14.6381C14.3981 14.3777 14.3981 13.9556 14.1377 13.6952L11.4504 11.0079C12.2119 10.043 12.6663 8.82456 12.6663 7.49998C12.6663 4.37037 10.1293 1.83331 6.99967 1.83331Z","fill":"currentColor"}})])
          )
        }
      }
    